import { inject } from '@angular/core';
import { RedirectCommand, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { WorkspaceViewerService } from './workspace-viewer.service';

export const workspaceViewerOnboardedRedirectGuard = () => {
  const viewerService = inject(WorkspaceViewerService);
  const router = inject(Router);

  return viewerService.getViewer().pipe(
    map((viewer) => {
      if (viewer.isOnboarded) {
        return true;
      } else {
        return new RedirectCommand(router.parseUrl('/onboarding'));
      }
    }),
  );
};
